import Moment from 'moment'
import * as React from 'react';
import 'react-dates/initialize';
import Header from '../static/Header';
import {withAlert} from "react-alert";
import compose from 'recompose/compose';
import DatePicker from 'react-datepicker'
import {Button} from '../static/Elements';
import {states} from '../../utils/states';
import connect from "react-redux/es/connect/connect";
import {DropdownField, FormInput, TextField} from "../static/Inputs";
import {postAgenciesReport, postLeadReport} from "../../data/dashboard/dashboardActions";

class Dashboard extends React.Component {

  /*----- Lifecycle methods -----*/
  constructor(props){
    super(props);
    this.fileInput = React.createRef();
    this.state = {
      dateRange: {
          start: Moment().hours(0).minutes(0).second(0).subtract(7, 'days').toDate(),
          end: Moment().hours(0).minutes(0).seconds(0).toDate(),
      },
      agency: '',
      state: 'All',
      email: '',
    }
  }

  /*----- Event handlers -----*/
  clearState = () => {
    this.setState({
      dateRange: {
        start: Moment().hours(0).minutes(0).second(0).subtract(7, 'days').toDate(),
        end: Moment().hours(0).minutes(0).seconds(0).toDate(),
      },
      agency: '',
      state: 'All',
      email: '',
    })
  };

  onDateChange = (field) => (input) => {
    console.log(`setting ${field} to ${input}`);
    this.setState({dateRange: {...this.state.dateRange, [field]: input}});
  };

  onInputChange = (field) => (input) => {
    console.log(`setting ${field} to ${input}`);
    this.setState({[field]: input})
  };

  customReport = () => {
    const {start, end} = this.state.dateRange;
    const {postLeadReport, alert} = this.props;
    const {agency, state, email} = this.state;
    const config = {agency, state, email, start, end};
    console.log(config);
    postLeadReport(config).then(() => {
      alert.success(<p className={`alert-message`}>Spreadsheet generation successfully started</p>);
    }).catch(() => {
      alert.error(<p className={`alert-message`}>Problem with spreadsheet generation</p>);
      }
    );
    this.clearState()
  };

  agenciesReport = () => {
    const {postAgenciesReport, alert} = this.props;
    console.log(`fileInput: `, this.fileInput);
    const fileRef = this.fileInput.current.files[0];
    postAgenciesReport(fileRef).then(() => {
      alert.success(<p className={`alert-message`}>Spreadsheet generation successfully started</p>);
    }).catch(() => {
      alert.error(<p className={`alert-message`}>Problem with spreadsheet generation</p>);
    });
    this.clearState();
  };

  /*----- Render -----*/
  render () {

    const {
      start,
      end,
    } = this.state.dateRange;

    const {
      agency,
      state,
      email,
    } = this.state;

    const {
      onDateChange,
      onInputChange,
      customReport,
      agenciesReport,
    } = this;

    const startDateConfig = {
      selected: start,
      startDate: start,
      onChange: onDateChange('start'),
      endDate: end,
      className: `date-picker-field`,
    };

    const endDateConfig = {
      selected: end,
      startDate: start,
      onChange: onDateChange('end'),
      endDate: end,
      minDate: start,
      className: `date-picker-field`,
    };

    const statesDropdownConfig = {
      type: 'text',
      value: state,
      label: "State",
      onChange: onInputChange(`state`),
      defaultValue: 'All',
    };

    const agencyFieldConfig = {
      type: 'text',
      label: 'Agency',
      onChange: onInputChange('agency'),
      value: agency,
    };

    const emailFieldConfig = {
      type: 'text',
      label: 'Email',
      onChange: onInputChange('email'),
      value: email,
    };

    return (
      <main>
        <Header top/>
        <div className={`dashboard-layout`}>
          <h2>Dashboard</h2>
          <div className={`dashboard-container`}>

            <FormInput className={`dashboard-form`} onSubmit={customReport}>
              <div className={`customer-report-container`}>
                <h5>Generate custom Lead spreadsheet</h5>
                <div className={`date-range-container`}>
                  <div className={`field-container`}>
                    <label>Start Date</label>
                    <DatePicker {...startDateConfig}/>
                  </div>
                  <div className={`field-container`}>
                    <label>End Date</label>
                    <DatePicker {...endDateConfig}/>
                  </div>
                </div>
                <div className='split-line-field'>
                  <div className={`field-container`}>
                    <TextField {...agencyFieldConfig} />
                  </div>
                  <div className={`field-container`}>
                    <DropdownField {...statesDropdownConfig}>
                      <option value={'All'} key={"all"} className='dropdown-item'>All</option>
                      {
                        states.map((stateName) => (
                          <option value={stateName} key={stateName} className='dropdown-item'>{stateName}</option>
                        ))
                      }
                    </DropdownField>
                  </div>
                </div>
                <div className={`full-line-field`}>
                  <TextField {...emailFieldConfig}/>
                </div>
                <div className={`generation`}>
                  <Button primary type='submit'>
                      Generate Spreadsheet
                  </Button>
                </div>
              </div>
            </FormInput>

            <FormInput className={`file-upload-form`} onSubmit={agenciesReport}>
              <div className={`file-upload-container`}>
                <h5>Populate ID spreadsheet with agencies</h5>
                <div>
                  <label>Select Job ID .xlsx file</label>
                  <input type="file" ref={this.fileInput} className={`file-upload`} />
                </div>
                <div className={`generation`}>
                  <Button primary type='submit'>
                    Generate Spreadsheet
                  </Button>
                </div>
              </div>
            </FormInput>

          </div>
        </div>
      </main>
    )
  }
}

export default compose(withAlert,
  connect(null, {
    postLeadReport,
    postAgenciesReport,
  })) (Dashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js